import { render, staticRenderFns } from "./ChallengeButton.vue?vue&type=template&id=7b8d9ffe&scoped=true&"
import script from "./ChallengeButton.vue?vue&type=script&lang=js&"
export * from "./ChallengeButton.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeButton.vue?vue&type=style&index=0&id=7b8d9ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d9ffe",
  null
  
)

export default component.exports